import { render, staticRenderFns } from "./ShiftEditorWork.vue?vue&type=template&id=812552fc&scoped=true&lang=pug&"
import script from "./ShiftEditorWork.vue?vue&type=script&lang=ts&"
export * from "./ShiftEditorWork.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftEditorWork.vue?vue&type=style&index=0&id=812552fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812552fc",
  null
  
)

export default component.exports